import React from 'react';
import Modal from '../../../../component/modal/ModalTemplate';


class RefundSuccessModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }// end constructor

    render() {
        const { isOpen, handleClose, paymentInfo } = this.props;
        return (
            <Modal  open={isOpen}
                    handleClose={handleClose}
                    className={`react-modal`}
                    modalTitle={"환불 신청 완료"}
            >

                <div className='modal-body'>
                    <p className='text-primary'>환불 신청 완료 되었습니다.</p>
                    <p>확인 절차를 거쳐 <b>14일</b> 이내 진행 완료 될 예정입니다.</p>
                    <h4 className='fs-5'>환불 예상 금액 : <span className='text-danger'>{Math.floor(paymentInfo.balance - (paymentInfo.balance * 0.1 + Math.floor(paymentInfo.amount*1.1) * 0.03 + 500))} 원</span> </h4>
                </div>
                <div className='modal-footer'>
                    <button className='btn btn-primary btn-md me-2' onClick={handleClose}>확인</button>
                </div>
            </Modal>
        )
    }
} //end class

export default RefundSuccessModal;

